'use client';

import { Container, Paper, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import type { PageWidgetItem } from '../../../types/content';
import {
  widgetSectionPadding,
  widgetTitleStyle,
} from './widgetStyles';

export function MetricsStripWidget({
  title,
  subtitle,
  items,
}: {
  title?: string;
  subtitle?: string;
  items: PageWidgetItem[];
}) {
  if (!items.length) return null;

  const description =
    subtitle ||
    items.find((item) => item.body)?.body ||
    'Keskeiset tulokset yhdellä näkymällä.';

  return (
    <Container size="xl" py={widgetSectionPadding}>
      <Paper
        p={{ base: 20, md: 34 }}
        radius={40}
        withBorder
        style={{
          borderColor: 'var(--surface-border)',
          borderWidth: 1.5,
          background: 'var(--surface-soft)',
        }}
      >
        <SimpleGrid cols={{ base: 1, md: 2 }} spacing={{ base: 18, md: 24 }}>
          <Stack gap={10}>
            {title ? (
              <Title order={2} style={{ ...widgetTitleStyle, fontSize: 'clamp(1.8rem, 3.1vw, 2.35rem)' }}>
                {title}
              </Title>
            ) : null}
            <Text style={{ color: 'var(--text-secondary)', lineHeight: 1.75, maxWidth: 560 }}>{description}</Text>
          </Stack>

          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={10}>
            {items.map((item, index) => (
              <Paper
                key={`${item.value || item.label || 'metric'}-${index}`}
                p={{ base: 16, md: 18 }}
                radius={26}
                withBorder
                style={{
                  borderColor: 'var(--surface-border)',
                  borderWidth: 1.5,
                  background: index % 2 === 0 ? 'var(--surface-base)' : 'var(--surface-alt)',
                }}
              >
                <Stack gap={4}>
                  <Text style={{ color: 'var(--text-primary)', fontWeight: 700, fontSize: 'clamp(1.8rem, 3vw, 2.25rem)' }}>
                    {item.value || item.title || '-'}
                  </Text>
                  <Text size="sm" style={{ color: 'var(--text-primary)', fontWeight: 600 }}>
                    {item.label || ''}
                  </Text>
                  {item.body ? (
                    <Text size="sm" style={{ color: 'var(--text-secondary)', lineHeight: 1.65 }}>
                      {item.body}
                    </Text>
                  ) : null}
                </Stack>
              </Paper>
            ))}
          </SimpleGrid>
        </SimpleGrid>
      </Paper>
    </Container>
  );
}
